export const allowedDevEmails = [
    'marchitommaso8@gmail.com',
    'tommaso.marchi@holifya.com',
    'tommasomarchi95@gmail.com',
    'tonihatsu@gmail.com',
];

export const isDevEmail = (email?: string) => {
    return email ? allowedDevEmails.includes(email) : false;
};